import LogRocket from 'logrocket';
import { O8TrackingModuleOptions, TrackingService } from './tracker.interface';
import { EMPTY, Subject, filter, from, switchMap, tap } from 'rxjs';
import type { UserService } from '../login/providers';
import { LazyInject } from '../../shared-providers';
import { getRandomUuidFromWindow } from '../uuid';

/* No need for injectable decorator as it is created through a factory*/
export class TrackerBrowserService implements TrackingService {
  sessionId!: string; /* Initialized in the lifetime of the app*/
  unsubscribe$ = new Subject<void>();
  hasInit = false;
  options!: O8TrackingModuleOptions & { enableSessionRecording: boolean };
  constructor(
    private lazyInject: LazyInject,
    private logRocket: typeof LogRocket,
  ) {}

  captureException(error: Error, extra?: object): void {
    this.logRocket.captureException(error, extra);
  }

  track(
    event: string,
    data: { [key: string]: string | number | boolean | string[] | number[] | boolean[] | undefined },
  ): void {
    this.logRocket.track(event, data);
  }

  initialize(options: O8TrackingModuleOptions & { enableSessionRecording: boolean }) {
    this.options = options;
    this.options.appId
      .pipe(
        filter((id) => !!id && !this.hasInit),
        tap((id) => {
          // if (this.options.enableSessionRecording) {
          //   this.logRocket.init(id as string, {
          //     console: { shouldAggregateConsoleErrors: true },
          //     rootHostname: 'origin8cares.com',
          //     shouldParseXHRBlob: true,
          //     network: {
          //       requestSanitizer: (request) => {
          //         request.headers['Authorization'] = '';
          //         request.headers['authorization'] = '';
          //         return request;
          //       },
          //     },
          //   });
          // }
        }),
        tap(() => {
          this.hasInit = true;
        }),
        switchMap(() => {
          if (this.options.anonymous) {
            return EMPTY;
          }
          /* Lazy load the user service only if we are in non anonymous mode*/
          return from(this.getUserService());
        }),
        // switchMap((userService) => {
        //   return userService.getUser$().pipe(
        //     filter((user) => !!user?.email),
        //     first(),
        //     tap((user) => {
        //       const usr = user as O8User;
        //       this.logRocket.identify(usr.email, fp.pick(usr, 'name', 'email'));
        //     }),
        //   );
        // }),
      )
      .subscribe();
  }

  getSessionId(): string {
    if (!this.sessionId) {
      this.sessionId = getRandomUuidFromWindow();
    }
    return this.sessionId;
  }

  getRequestId(): string {
    return getRandomUuidFromWindow();
  }

  private getUserService() {
    return this.lazyInject.get<UserService>(() => import('../login/providers').then((m) => m.UserService));
  }
}
